import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../helpers/export'
import ReportService from './ReportService'

export const getReportItem = createAsyncThunk(
  'companyAnalysis/factSheet/getReportItem',
  async (params, { rejectWithValue }) => {
    try {
      const [data, sources] = await Promise.all([
        ReportService.getReportItem(params),
        ReportService.getReportSources(params),
      ])

      if (!data.success || !sources.success) {
        return rejectWithValue({ isLoading: false })
      }

      return {
        data: data.data,
        sources: sources.data,
      }
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)

export const getSampleReport = createAsyncThunk(
  'companyAnalysis/factSheet/getSampleReport',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ReportService.getSampleReport(params)
      handleExport(response.data, response.filename)
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const getDataAvailability = createAsyncThunk(
  'companyAnalysis/factSheet/getDataAvailability',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ReportService.getDataAvailability(params)
      if (response.success) {
        return response.data
      }
      return rejectWithValue(false)
    } catch (error) {
      return rejectWithValue(axios.isCancel(error))
    }
  },
)
